import { openForm as legacyOpenForm } from '~/legacy/screens'

/** Thème clair / sombre (`applyTheme`, `toggleTheme`) : au démarrage, celui du système. */
export function useTheme() {
  return useState<'light' | 'dark'>('currentTheme', () => 'light')
}

export function toggleTheme(): void {
  const theme = useTheme()
  theme.value = theme.value === 'dark' ? 'light' : 'dark'
  localStorage.setItem('theme', theme.value)
}

/** `showToast` de la maquette : un message qui disparaît après 2,4 s. */
export function useToasts() {
  return useState<{ id: number, msg: string }[]>('toasts', () => [])
}

let toastCounter = 0
export function showToast(msg: string): void {
  const toasts = useToasts()
  const id = ++toastCounter
  toasts.value = [...toasts.value, { id, msg }]
  setTimeout(() => {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }, 2400)
}

/** Menus déroulants de la barre du haut. */
export function useMenus() {
  return { ctxOpen: useState('ctxOpen', () => false), notifOpen: useState('notifOpen', () => false) }
}

export function closeCtxMenu(): void {
  useMenus().ctxOpen.value = false
}

export function closeNotifMenu(): void {
  useMenus().notifOpen.value = false
}

export function toggleCtxMenu(evt?: Event): void {
  evt?.stopPropagation()
  const { ctxOpen } = useMenus()
  ctxOpen.value = !ctxOpen.value
}

export function toggleNotifMenu(evt?: Event): void {
  evt?.stopPropagation()
  closeCtxMenu()
  const { notifOpen } = useMenus()
  notifOpen.value = !notifOpen.value
}

/** `setCurrentEcole` de la maquette. */
export function setCurrentEcole(id: string): void {
  const allowedIds = useCurrentUser().value?.ecoleIds
  if (allowedIds && !allowedIds.includes(id)) {
    showToast('Cette école n\'est pas dans votre périmètre.')
    return
  }
  useCurrentEcoleId().value = id
  localStorage.setItem('currentEcoleId', id)
  showToast(`École sélectionnée : ${ecoleLabelText(findById('ecoles', id))}`)
}

/**
 * `openForm` de la maquette (formulaire d'une entité) : ouvre la fenêtre, avec ses champs déjà remplis pour une modification.
 * L'affichage est repris tel quel de la maquette ; l'enregistrement (`submitForm`, appelé par le bouton « Enregistrer » de la
 * fenêtre) est dans `useEntityForm.ts`, qui écrit dans l'API Java au lieu d'une base en mémoire.
 */
export function openForm(entity: string, id?: string | null, prefill?: Record<string, unknown>): void {
  legacyOpenForm(entity, id ?? null, prefill ?? null)
}

/** Titre de la barre du haut quand la page en impose un autre que celui de la vue (fiche « Introuvable »). */
export function useTitleOverride() {
  return useState<string | null>('titleOverride', () => null)
}
